import { render, staticRenderFns } from "./DomainTraffic.vue?vue&type=template&id=350f1570"
import script from "./DomainTraffic.vue?vue&type=script&lang=js"
export * from "./DomainTraffic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports